// 動きの速さの変わり方（段階 C の2 の 7g、2026-10-26。前は d3 v4.10.2 の d3.ease*。d3-ease, Copyright 2010-2017 Mike Bostock, BSD-3-Clause と同じ式）。
// ページの chibiConfig.REVERSE_EASE は d3 の名前（"easeBounceInOut" など）で書くので、EASES は同じ名前で引けるようにする
export type Ease = (t: number) => number;

export const easeLinear: Ease = (t) => +t;
export const easeCubicInOut: Ease = (t) => ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
export const easeCircleInOut: Ease = (t) => ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;

const OVERSHOOT = 1.70158;
export const easeBackOut: Ease = (t) => --t * t * ((OVERSHOOT + 1) * t + OVERSHOOT) + 1;

// 弾む（振れ幅 1・周期 0.3）
const TAU = 2 * Math.PI, AMP = 1, PERIOD = 0.3 / TAU, SHIFT = Math.asin(1 / AMP) * PERIOD;
export const easeElasticOut: Ease = (t) => 1 - AMP * Math.pow(2, -10 * (t = +t)) * Math.sin((t + SHIFT) / PERIOD);

const b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
export const easeBounceOut: Ease = (t) =>
  (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
export const easeBounceInOut: Ease = (t) => ((t *= 2) <= 1 ? 1 - easeBounceOut(1 - t) : easeBounceOut(t - 1) + 1) / 2;

/** d3 の名前で引く（d3.easeElastic は easeElasticOut、d3.easeCircle は easeCircleInOut、d3.easeCubic は easeCubicInOut） */
export const EASES = {
  easeLinear,
  easeCubic: easeCubicInOut,
  easeCubicInOut,
  easeCircle: easeCircleInOut,
  easeCircleInOut,
  easeBack: (t: number) => ((t *= 2) < 1 ? t * t * ((OVERSHOOT + 1) * t - OVERSHOOT) : (t -= 2) * t * ((OVERSHOOT + 1) * t + OVERSHOOT) + 2) / 2,
  easeBackOut,
  easeElastic: easeElasticOut,
  easeElasticOut,
  easeBounce: easeBounceOut,
  easeBounceOut,
  easeBounceInOut,
} satisfies Record<string, Ease>;
/** d3 の名前の速さの変わり方（無ければ null） */
export const easeByName = (name: string): Ease | null => (Object.prototype.hasOwnProperty.call(EASES, name) ? (EASES as Record<string, Ease>)[name] : null);
